import { render, staticRenderFns } from "./ReviewItems.vue?vue&type=template&id=284f084b&scoped=true&"
import script from "./ReviewItems.vue?vue&type=script&lang=js&"
export * from "./ReviewItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f084b",
  null
  
)

export default component.exports